import { Tab, Tabs, styled } from "@mui/material";

export const RpTabs = styled(Tabs)(() => ({
  minWidth: "auto",
  minHeight: "auto",
  width: "auto",
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

export const RpTab = styled(Tab)(({ theme }) => ({
  borderRadius: "var(--radius-control)",
  minWidth: "auto",
  minHeight: "auto",
  backgroundColor: "var(--primary-tint)",
  color: (theme.vars || theme)?.palette?.primary?.main,
  margin: "auto 5px",
  padding: "4px 12px",
  // Same metrics as a small MUI Button so tabs line up with Expand All.
  fontSize: theme.typography.pxToRem(13),
  lineHeight: 1.75,
  fontWeight: 600,
  textTransform: "none",
  opacity: 1,
  "&:hover": {
    backgroundColor: "var(--primary-tint-hover)",
  },
  "&.Mui-selected": {
    backgroundColor: (theme.vars || theme)?.palette?.primary?.main,
    color: (theme.vars || theme)?.palette?.primary?.contrastText,
  },
  "& .MuiTab-wrapper": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  "& .MuiTab-iconWrapper": {
    fontSize: 16, // controls SvgIcon size when no explicit sx given
    marginRight: theme.spacing(1),
    display: "inline-flex",
    alignItems: "center",
  },
}));
